import styled from "@emotion/styled";
import { Box, Button, Divider } from "@mui/material";
import { base, grayModern } from "configs/colors";

import linePatternBottom from "./assets/images/line-pattern-bottom.png";
import linePatternTop from "./assets/images/line-pattern-top.png";

export const PageContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: ${base.White};
`;

export const LeftSection = styled(Box)<{ mdUpMatched: boolean }>(
  ({ mdUpMatched }) => ({
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    width: mdUpMatched ? "50%" : "100%",
    background: mdUpMatched
      ? undefined
      : "linear-gradient(45deg, #42307d 0%, #7f56d9 100%)",
  })
);

export const RightSection = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background: linear-gradient(45deg, #42307d 0%, #7f56d9 100%);
  min-height: 100vh;
  width: 50%;

  &:before {
    content: "";
    position: absolute;
    background-image: url(${linePatternTop});
    background-size: contain;
    background-repeat: no-repeat;
    top: 0;
    right: 0;
    max-width: 298px;
    max-height: 408px;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  &:after {
    content: "";
    position: absolute;
    background-image: url(${linePatternBottom});
    background-size: contain;
    background-repeat: no-repeat;
    bottom: 0;
    left: 0;
    max-width: 258px;
    max-height: 152px;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
`;

export const ContentImage = styled.img`
  position: relative;
  z-index: 2;
`;

export const FormContainer = styled(Box)`
  background-color: ${base.White};
  border-radius: 8px;
  padding: 24px;
  max-width: 408px;
  width: 100%;
`;

export const AzureIcon = styled.img`
  width: 22px;
  height: 22px;
  background: ${base.White};
  border-radius: 50%;
  padding: 1px;
`;

export const ORContainer = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const ORButton = styled(Button)`
  border-radius: 8px;
  margin: 24px 16px;
  width: 40%;
  pointer-events: none;
  border-color: ${grayModern[100]};
`;

export const ORDivider = styled(Divider)`
  width: 30%;
  border-color: ${grayModern[100]};
`;
